module.exports = __webpack_public_path__ + "static/media/delete.07565f93.svg";